module.exports = __webpack_public_path__ + "static/media/fsyuce023.daf05165.jpg";